import { errorMessage } from '../consts';
import { logger } from '../utils';
import { notify } from "../utils/notify";

export const handleCatchReducer = (type: string, err: any) => {
	logger(`@${type}Reducer`, err);
	notify(`${errorMessage}\n${type} reducer threw an error.`, "error");
};
